function Phone_onKey_Up_Down(event, field) {
    var inputChar = event.which || event.keyCode;
    var strInput = field.value;
    //console.log(strInput);
    if (inputChar == 0 || inputChar == 8 || inputChar == 9 || inputChar == 13 || inputChar == 46 || inputChar == 37 || inputChar == 39 || inputChar == 40 || inputChar == 41)// keycode enter = 13; 
        //Allow tab(0-firefox); delete (0-firefox) ; backSpace(8) //check if key pressed is a number from either the key pad or keyboard number row dash(45)
        //check if key pressed is a backspace(8), tab(9), enter(13), delete(46), left arrow(37), control(17),or right arrow(39)
    {
        if ((inputChar == 13 || inputChar == 9) && strInput.length == 10 && strInput.indexOf("(") < 0 && strInput.indexOf(")") < 0 && strInput.indexOf("-") < 0) {
            strInput = "({first}) {second}-{third}".replace("{first}", strInput.substring(0, 3)).replace("{second}", strInput.substring(3, 6)).replace("{third}", strInput.substring(6));
            field.value = strInput;
        }
        return true;
    }
    else if ((inputChar >= 48 && inputChar <= 57) || (inputChar >= 96 && inputChar <= 105)) {
        //the dash is either 189 (chrome nd IE), 173 (firefox), or 109 (input from keypad, same in all 3 browsers)
        if (strInput.length == 1 && strInput.indexOf("(") < 0) {
            field.value = "(" + strInput;
            return true;
        }
        //When missing both parenthesises
        if (strInput.length == 5 && strInput.indexOf(")") < 0) {
            if (strInput.indexOf("(") < 0) {
                strInput = "({firstPart}) {secondPart}".replace("{firstPart}", strInput.substring(0, 3)).replace("{secondPart}", strInput.substring(3));
            }
            else {
                strInput = strInput.substring(0, 4) + ") " + strInput.substring(4);
            }

            field.value = strInput;
            return true;
        }
        if (strInput.length == 7 && strInput.indexOf(" ") < 0) {
            strInput = strInput.substring(0, 5) + " " + strInput.substring(5);
            field.value = strInput;
            return true;
        }
        if (strInput.length == 9 && strInput.indexOf("-") < 0) {
            field.value += "-";
            return true;
        }
        if (strInput.length > 0 && strInput.length <= 14 && strInput.indexOf("(") < 0 && strInput.indexOf(")") < 0 && strInput.indexOf("-") < 0) //When number is not formatted
        {
            strInput = "({firstPart}) {secondPart}-{thirdPart}".replace("{firstPart}", strInput.substring(0, 3)).replace("{secondPart}", strInput.substring(3, 6)).replace("{thirdPart}", strInput.substring(6));
            field.value = strInput;
        }
        else if (strInput.length >= 9 && strInput.length <= 14 && strInput.indexOf("-") < 0) {
            field.value = strInput.substring(0, 9) + "-" + strInput.substring(9);
        }

        if (strInput.length > 14) {
            return false;
        }
        return true;
    }
    return false;
}

function formatPhoneNumber(s) {
    if (s?.length > 10 && s.substring(0, 1) == '1') {
        s = s.substr(1);
    }
    var s2 = ("" + s).replace(/\D/g, '');
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
}

function Zip_onKeyPress(event, field) {
    var inputChar = window.event ? event.keyCode : event.which;
    var strInput = field.value;

    if (event.shiftKey == false)
        //check if shift key is not being used
    {
        if (inputChar == 0 || inputChar == 8 || inputChar == 9 || inputChar == 13 || inputChar == 46 || inputChar == 37 || inputChar == 39)// keycode enter = 13; 
            //Allow tab(0-firefox); delete (0-firefox) ; backSpace(8)
            //check if key pressed is a backspace(8), tab(9), enter(13), delete(46), left arrow(37), or right arrow(39)
        {
            return true;
        }
        else if ((inputChar != 0 && (inputChar >= 48 && inputChar <= 57)) || ((inputChar == 189 || inputChar == 173 || inputChar == 109 || inputChar == 45) && strInput.length == 5)) {
            //check if key pressed is a number from either the key pad or keyboard number row dash(45)
            //the dash is either 189 (chrome nd IE), 173 (firefox), or 109 (input from keypad, same in all 3 browsers)
            if (strInput.length == 6 && inputChar != 45 && strInput.indexOf("-") <= 0) {
                field.value = strInput.substring(0, 5) + "-" + strInput.substring(5);
                //strInput += "-";
                //    field.value = strInput;
                return true;
            }

            if (strInput.length > 10) {

                return false;
            }
            if (strInput.length > 5 && strInput.length < 10 && strInput.indexOf("-") <= 0) {
                field.value = strInput.substring(0, 5) + "-" + strInput.substring(5);
            }
            return true;
        }
        else if (strInput.length > 5 && strInput.length < 10 && strInput.indexOf("-") >= 0 && (inputChar == 189 || inputChar == 173 || inputChar == 109 || inputChar == 45)) {
            //If dash exist stop user from enter more dashes
            return false;
        }
        return false;
    }
    return false;
}

function SSN_onKeyPress(field, event) {
    var inputChar = window.event ? event.keyCode : event.which;
    if (inputChar == 13 || inputChar == 8) {
        return true;
    }
    else if (inputChar != 0 && (inputChar < 48 || inputChar > 57)) {
        return false;
    }

    var strInput = field.value;
    if (strInput.length == 3 || strInput.length == 6)
        field.value += "-";

    if (strInput.length > 11)
        return false;

    return true;
}

function Time_onKeyPress(event, field) {
    var inputChar = window.event ? event.keyCode : event.which;
    var strInput = field.value;

    if (event.shiftKey == false)
        //check if shift key is not being used
    {
        if (inputChar == 0 || inputChar == 8 || inputChar == 9 || inputChar == 13 || inputChar == 46 || inputChar == 37 || inputChar == 39)// keycode enter = 13; 
            //Allow tab(0-firefox); delete (0-firefox) ; backSpace(8)
            //check if key pressed is a backspace(8), tab(9), enter(13), delete(46), left arrow(37), or right arrow(39)
        {
            return true;
        }
        else if ((inputChar != 0 && (inputChar >= 48 && inputChar <= 57)) || ((inputChar == 189 || inputChar == 173 || inputChar == 109 || inputChar == 45) && strInput.length == 5)) {
            //check if key pressed is a number from either the key pad or keyboard number row dash(45)
            //the dash is either 189 (chrome nd IE), 173 (firefox), or 109 (input from keypad, same in all 3 browsers)
            if (strInput.length == 1 && inputChar != 45 && strInput.indexOf(":") <= 0) {
                field.value = strInput + ":";
                //    //strInput += "-";
                //    //    field.value = strInput;
                //    return true;
            } else if (strInput.length == 2 && inputChar != 45 && strInput.indexOf(":") <= 0) {
                field.value = strInput.substring(0, 2) + ":";
                //    //strInput += "-";
                //    //    field.value = strInput;
                //    return true;
            }

            if (strInput.length > 4) {
                return false;
            }
            if (strInput.length > 3 && strInput.length <= 5) {
                if (strInput.indexOf(":") > 0) {
                    strInput = strInput.replace(":", "");
                }
                field.value = strInput.substring(0, 2) + ":" + strInput.substring(2);
            } else if (strInput.length > 1 && strInput.length < 4 && strInput.indexOf(":") <= 0) {
                if (strInput.indexOf(":") > 0) {
                    strInput = strInput.replace(":", "");
                }
                field.value = strInput.substring(0, 1) + ":" + strInput.substring(1);
            }
            return true;
        }
        else if (strInput.length > 1 && strInput.length < 4 && strInput.indexOf(":") >= 0 && (inputChar == 186 || inputChar == 59 || inputChar == 58)) {
            //If dash exist stop user from enter more dashes
            return false;
        }
        return false;
    }
    return false;
}

function NumbersOnly(field, event) {
    var inputChar = window.event ? event.keyCode : event.which;
    if (inputChar == 13) {
        return true;
    }
    else if (inputChar != 0 && (inputChar < 48 || inputChar > 57)) {
        return false;
    }
}
function AlphaNumericChange(x) {
    var text = x.value;
    var id = x.id;
    x.value = text.replace(/[^a-z0-9]/gi, '');
}
function AlphaNumericOnly(field, event) {
    event = event || window.event;
    var charCode = event.which || event.keyCode;
    var charStr = String.fromCharCode(charCode);
    return (/[a-z0-9]/i.test(charStr)) ? true : false;
}

function Name_onKeyPress(event, field) {
    var inputChar = window.event ? event.keyCode : event.which;
    var strInput = field.value;


    if (inputChar == 0 || inputChar == 8 || inputChar == 9 || inputChar == 13 ||
        inputChar == 46 || inputChar == 37 || inputChar == 39 || (inputChar >= 48 && inputChar >= 57) || 
        (inputChar <= 90 && inputChar >= 65) || inputChar == 109)
    {
        return true;
    }
    else {
        return false;
    }
}

/*----------------------------------------------------------------
DATE VALIDATION AND MASKING
----------------------------------------------------------------*/
function Date_onChange(field) {
    if (!Date_Validate(field)) {
        document.getElementById(field.id).focus();
    }
    else {
        field.value = Date_Format(field.value);
    }
}

function Date_Validate(field) {
    var strInput = field.value;
    var strInputName = field.name;
    if (strInput.length == 0)
        return true;

    var month;
    var day;
    var year;

    if (strInput.indexOf("/") > 0) {
        month = strInput.substring(0, strInput.indexOf("/"));
        var pos = strInput.lastIndexOf("/")
        day = strInput.substring(strInput.indexOf("/") + 1, pos);
        if (strInput.indexOf("/") != strInput.lastIndexOf("/"))
            year = strInput.substring(strInput.lastIndexOf("/") + 1);
        else
            year = "";
    }
    else {
        if (strInput.length == 8) {
            month = strInput.substring(0, 2);
            day = strInput.substring(2, 4);
            year = strInput.substring(4, 8);
        }
        else {
            alert("Invalid date.");
            return false;
        }
    }
    if (year.length != 4) {
        alert("4 digits must be entered for the year.");
        return false;
    }
    month = month - 0;
    day = day - 0;
    year = year - 0;
    if (month == 0 || month > 12 || day == 0 || day > getDaysInMonth(month, year)) {
        alert("Invalid date");
        return false;
    }
    if (year > 2100) {
        alert("Date is too far in the future.");
        return false;
    }
    if (year < 1900) {
        alert("Date is too far in the past.");
        return false;
    }
    return true;
}

function Date_Format(strInput) {
    if (strInput.length == 0)
        return strInput;
    var month;
    var day;
    var year;
    if (strInput.indexOf("/", 0) == -1) {
        month = strInput.substring(0, 2) - 0;
        day = strInput.substring(2, 4) - 0;
        year = strInput.substring(4);
    }
    else {
        var pos1 = strInput.indexOf("/");
        month = strInput.substring(0, pos1) - 0;
        var pos2 = strInput.lastIndexOf("/");
        day = strInput.substring(pos1 + 1, pos2) - 0;
        var pos3 = strInput.lastIndexOf(" ");
        if (pos3 == -1)
            year = strInput.substring(pos2 + 1);
        else
            year = strInput.substring(pos2 + 1, pos3) - 0;
    }
    if (month < 10)
        month = "0" + month;
    if (day < 10)
        day = "0" + day;
    if (year.length < 4 && (year - 0) < 100)
        year = (year - 0) + 1900;
    return month + "/" + day + "/" + year;
}

function Date_onKey_Up_Down(field, event) {
    var inputChar = window.event ? event.keyCode : event.which;
    var strInput = field.value;
    //console.log(inputChar);

    if ((inputChar >= 48 && inputChar <= 57) || (inputChar >= 96 && inputChar <= 105)) {
        //check if key pressed is a number
        //console.log("Number");
        if (strInput.length > 10) {
            event.preventDefault();
            return;
        } else {
            if (strInput.length == 2) {
                strInput = strInput + "/";
                field.value = strInput;
            } else if (strInput.length == 5) {
                strInput = strInput + "/";
                field.value = strInput;
            }
        }
    } else if (inputChar == 191 || inputChar == 111) {
        //check if key pressed is a forward slash (/)
        //console.log("Forward Slash");

        //count existing forward slashes
        var slashCount = (strInput.match(/\//g) || []).length

        //split input on the slashes
        var temp = strInput.split("/");

        if (strInput.length > 10 || slashCount == 2) {
            event.preventDefault();
            return;
        } else {

            if (strInput.length == 1 && slashCount == 0 && strInput != "0") {
                //add a leading zero to the month
                strInput = "0" + strInput;
                field.value = strInput;
            } else if (strInput.length == 2 && slashCount == 0) {
                //allow slash
            } else if (strInput.length == 4 && slashCount == 1 && temp[1] != "0") {
                //add a leading zero to the day                
                strInput = temp[0] + "/0" + temp[1];
                field.value = strInput;
            } else if (strInput.length == 5 && slashCount == 1) {
                //allow slash
            } else {
                //slash not allowed
                event.preventDefault();
                return;
            }
        }
    } else if (inputChar == 8 || inputChar == 9 || inputChar == 13 || inputChar == 46 || inputChar == 37 || inputChar == 39) {
        //check if key pressed is a backspace(8), tab(9), enter(13), delete(46), left arrow(37), or right arrow(39)
        //console.log("Misc");
    } else {
        //console.log("Char not allowed");
        event.preventDefault();
        return;
    }

    //reformat the string if it is highlighted and overwritten
    if (event.type == "keyup") {
        var temp = field.value;
        result = reformatNumbersAsDate(temp);
        field.value = result;
    }
}
function reformatNumbersAsDate(input) {
    var result = "";

    //remove an errant slashes
    input = input.replace(/\//g, "");

    //spit input string into individual characters
    var arr = input.split("");

    //add slashes at approriate intervals
    for (var i = 0; i < arr.length; i++) {
        if (i < 8) {
            if (i == 2) {
                result = result + "/" + arr[i];
            } else if (i == 4) {
                result = result + "/" + arr[i];
            } else {
                result = result + arr[i];
            }
        }
    }
    return result;
}

function getDaysInMonth(month, year) {
    var daysInMonth = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
    if (month == 2) // Test for leap year when Febrary is selected
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0) ? 29 : 28;
    else
        return daysInMonth[month - 1];
}

function removeSpecialCharacters(x) {
    setTimeout(() => {
        var text = x.value;
        x.value = text.replace(/[`;~#$%^&*|+\=<>\{\}\[\]\\]/gi, '');
    }, 50);
}

function sanitizeInput(x) {
    setTimeout(() => {
        var text = x.value;

        // Allow only letters, numbers, and typical email special characters
        x.value = text.replace(/[^a-zA-Z0-9@._+\-\s']/g, '');

        // HTML encoding
        x.value = text.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

        // Additional JS XSS checks
        x.value = text.replace(/javascript:/gi, '')
            .replace(/data:/gi, '')
            .replace(/vbscript:/gi, '')
            .replace(/onclick/gi, '')
            .replace(/onload/gi, '')
            .replace(/onmouseover/gi, '')
            .replace(/onmouseout/gi, '')
            .replace(/onkeydown/gi, '')
            .replace(/onkeypress/gi, '')
            .replace(/onkeyup/gi, '');

    }, 50);
}

function numericOnly(x) {
    var charCode = (x.which) ? x.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}

function getUrlParamByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// Knockout Utilities
if (typeof ko != "undefined") {
    // Blurs the selected input, textarea, or select element when 'enter' is press
    // To allow knockout to update the observable field value
    ko.bindingHandlers.enterkey = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var allBindings = allBindingsAccessor();

            $(element).on('keydown', 'input, select', function (e) {
                var keyCode = e.which || e.keyCode;
                if (keyCode !== 13) {
                    return true;
                }

                var target = e.target;
                target.blur();

                allBindings.enterkey.call(viewModel, viewModel, target, element);

                return false;
            });
        }
    };

    // Here's a custom Knockout binding that makes elements shown/hidden via jQuery's fadeIn()/fadeOut() methods
    // Could be stored in a separate utility library
    // Based on http://knockoutjs.com/examples/animatedTransitions.html
    ko.bindingHandlers.fadeVisible = {
        init: function (element, valueAccessor) {
            // Initially set the element to be instantly visible/hidden depending on the value
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
        },
        update: function (element, valueAccessor) {
            // Whenever the value subsequently changes, slowly fade the element in or out
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
        }
    };

    // Here's a custom Knockout binding that makes elements shown/hidden via jQuery's slideUp()/slideDown() methods
    // Could be stored in a separate utility library
    // Based on Animated Transitions: http://knockoutjs.com/examples/animatedTransitions.html
    ko.bindingHandlers.slideVisible = {
        init: function (element, valueAccessor) {
            // Initially set the element to be instantly visible/hidden depending on the value
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
        },
        update: function (element, valueAccessor) {
            // Whenever the value subsequently changes, slowly fade the element in or out
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).slideDown() : $(element).slideUp();
        }
    };

    // Fades in an element when displaying it
    // Useful with ko if to fade in content when it becomes visible
    // Based on http://stackoverflow.com/questions/15510178/adding-effect-to-knockout-if-binding
    ko.bindingHandlers.fadeIn = {
        init: function (element) {
            $(ko.virtualElements.childNodes(element))
                .filter(function () { return this.nodeType == 1; })
                .hide()
                .fadeIn();
        }
    };
    ko.virtualElements.allowedBindings.fadeIn = true;

    // Set character limit to the text box
    ko.bindingHandlers.limitCharacters = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var allowedNumberOfCharacters = valueAccessor();
            var currentValue = allBindingsAccessor.get('value');
            var cutText = ko.unwrap(currentValue).substr(0, allowedNumberOfCharacters);
            currentValue(cutText);
        }
    };
}

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//Geolocation Functions
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
var t;
function initiate_geolocation(x) {
    t = x;
    navigator.geolocation.getCurrentPosition(handle_geolocation_query, handle_errors);
}
function handle_errors(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            alert("Unable to get your location.  Please enter a search term.");
            break;
        case error.POSITION_UNAVAILABLE:
            alert("Unable to get your location.  Please enter a search term.");
            break;
        case error.TIMEOUT:
            alert("Unable to get your location.  Please enter a search term.");
            break;
        default:
            alert("Unable to get your location.  Please enter a search term.");
            break;
    }
}
function handle_geolocation_query(position) {
    $("#" + t.id).parent().find('input').val(position.coords.latitude + " " + position.coords.longitude).change();

    results = $.getValues("https://maps.googleapis.com/maps/api/geocode/xml?latlng=" + position.coords.latitude + "," + position.coords.longitude + "&key=AIzaSyCUbYC7TEcr2YADl7DVtltSuBBpueIlSVo");

    var zipReturned = "";
    $(results).find('address_component').each(function () {
        if ($(this).find('type').text() == "postal_code") {
            if ($(this).find("long_name").text().length) {
                zipReturned = $(this).find("long_name").text();
            }
        }
    });

    $("#" + t.id).parent().find('input').val(zipReturned);
}

jQuery.extend({
    getValues: function (url) {
        var result = null;
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'xml',
            async: false,
            success: function (data) {
                result = data;
            }
        });
        return result;
    }
});
window.Phone_onKey_Up_Down = Phone_onKey_Up_Down;
window.formatPhoneNumber = formatPhoneNumber;
window.Zip_onKeyPress = Zip_onKeyPress;
window.SSN_onKeyPress = SSN_onKeyPress;
window.Time_onKeyPress = Time_onKeyPress;
window.NumbersOnly = NumbersOnly;
window.AlphaNumericChange = AlphaNumericChange;
window.AlphaNumericOnly = AlphaNumericOnly;
window.Name_onKeyPress = Name_onKeyPress;
window.Date_onChange = Date_onChange;
window.Date_Validate = Date_Validate;
window.Date_Format = Date_Format;
window.Date_onKey_Up_Down = Date_onKey_Up_Down;
window.reformatNumbersAsDate = reformatNumbersAsDate;
window.getDaysInMonth = getDaysInMonth;
window.removeSpecialCharacters = removeSpecialCharacters;
window.sanitizeInput = sanitizeInput;
window.numericOnly = numericOnly;
window.getUrlParamByName = getUrlParamByName;
window.initiate_geolocation = initiate_geolocation;